// @ts-check

/**
 * @file Renders a shared detail value text node.
 */

import PropTypes from "prop-types"
import {memo} from "react"
import {View} from "react-native"

import Text from "./text"

/** @import {ReactElement} from "react" */

/**
 * @typedef {object} DetailValueProps
 * @property {object | object[]} [style] Visible text style.
 * @property {string} testID Stable detail value test id.
 * @property {string} value Visible and accessible value text.
 */

/**
 * Renders static detail text.
 * @param {DetailValueProps} props Component props.
 * @returns {ReactElement} Rendered detail value.
 */
function DetailValue({style, testID, value}) {
  return (
    <View
      accessible
      accessibilityLabel={value}
      collapsable={false}
      testID={testID}
    >
      <Text style={style}>
        {value}
      </Text>
    </View>
  )
}

DetailValue.propTypes = {
  style: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  testID: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired
}

DetailValue.defaultProps = {
  style: undefined
}

export default memo(DetailValue)
